import MuiPopover, { PopoverProps } from "@mui/material/Popover";
import classNames from "classnames";
import { ReactNode } from "react";
import * as popoverStyles from "./popover.module.css";

export interface RedoPopoverProps extends Omit<PopoverProps, "children"> {
  children: ReactNode;
  maxWidth?: string;
  maxHeight?: string;
  padding?: string;
}

export function Popover({
  className,
  children,
  maxWidth,
  maxHeight,
  padding,
  ...props
}: RedoPopoverProps) {
  return (
    <MuiPopover
      {...props}
      anchorOrigin={
        props.anchorOrigin || { vertical: "bottom", horizontal: "left" }
      }
      classes={{ paper: classNames(popoverStyles.paper, className) }}
      PaperProps={{
        style: {
          maxWidth: maxWidth || "320px",
          maxHeight: maxHeight || "400px",
        },
      }}
      transformOrigin={
        props.transformOrigin || { vertical: "top", horizontal: "left" }
      }
    >
      <div
        className={popoverStyles.content}
        style={{ padding: padding || "var(--redo-spacing-sm)" }}
      >
        {children}
      </div>
    </MuiPopover>
  );
}
